import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { useAuth } from '@/contexts/AuthContext'
import { type AppLanguage, resolveLanguage } from '@/services/i18n/languages'
import { settingsApi } from '../api'

/** Current language + a setter that switches the UI immediately and persists
 *  the choice to the server (non-blocking — a failed save is reconciled on
 *  the next /me read). */
export function useLanguagePreference() {
  const { i18n } = useTranslation()
  const { user, refreshUser } = useAuth()
  const language = resolveLanguage(i18n.language)

  const setLanguage = async (next: AppLanguage) => {
    i18n.changeLanguage(next)
    if (user && user.preferred_language !== next) {
      try {
        await settingsApi.updateLanguage(next)
        await refreshUser()
      } catch (err) {
        toast.error(`Couldn't save language preference: ${(err as Error).message}`)
      }
    }
  }

  return { language, setLanguage }
}
